export function italianTitlesToEnglish(title?: string) {
    switch (title) {
        case "Sig.":
            return "Mr";
        case "Sig.ra":
            return "Mrs";
        case "Sig.na":
            return "Miss";
        default:
            return title;
    }
}

export function englishTitlesToItalian(title?: string) {
    switch (title) {
        case "Mr":
            return "Sig.";
        case "Mrs":
            return "Sig.ra";
        case "Miss":
            return "Sig.na";
        default:
            return title;
    }
}
